export default __webpack_public_path__ + "static/media/specialRates.5b7f60b8.svg";